{
  "version": 1,
  "asset_id": "15b6253d-eb45-4de2-913e-44e9200d9e95",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/15b6253d-eb45-4de2-913e-44e9200d9e95/gastric-bypass-diagram-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/15b6253d-eb45-4de2-913e-44e9200d9e95/gastric-bypass-diagram-320.webp",
  "original_filename": "gastric-bypass-diagram-320.webp",
  "size": 14292,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:51Z"
}
